var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.file && _vm.constants.FILE_TYPES.img.includes((_vm.file.type || '').toLowerCase()) ? _c('img', {
    staticClass: "object-contain w-full h-screen rounded-md",
    attrs: {
      "src": '/depotdocs/' + _vm.file.full_path,
      "alt": ""
    }
  }) : _vm.file && _vm.constants.FILE_TYPES.pdf.includes((_vm.file.type || '').toLowerCase()) ? _c('embed', {
    staticClass: "w-full h-screen rounded-md",
    attrs: {
      "src": '/depotdocs/' + _vm.file.full_path
    }
  }) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }